import LoginHintBadgeService, { type TLoginHintBadge } from "@/api/models/user/loginHintBadge";
import { createQueryKeys, useGenericListQuery } from "@/composables/shared/queries";
import type { MaybeRefOrGetter } from "vue";

const LoginHintBadgeQueryKeys = createQueryKeys(LoginHintBadgeService.queryKey, (key) => ({
  inside: key("inside"),
}));

export const useLoginHintBadgesBeforeLogin = (enabled: MaybeRefOrGetter<boolean> = true) => {
  return useGenericListQuery<TLoginHintBadge>({
    queryKey: LoginHintBadgeQueryKeys.all(),
    fetcher: () => LoginHintBadgeService.getAll(),
    params: { enabled },
    suppressErrors: true,
    justQueryKey: true,
  });
};

export const useLoginHintBadgesInside = (enabled: MaybeRefOrGetter<boolean> = true) => {
  return useGenericListQuery<TLoginHintBadge>({
    queryKey: LoginHintBadgeQueryKeys.inside(),
    fetcher: () => LoginHintBadgeService.getInside({}),
    params: { enabled },
    permission: $permSubjects.USER__LOGINHINTBADGE,
    action: $permActions.SHOW_LOGINHINTBADGE,
    suppressErrors: true,
    justQueryKey: true,
  });
};
